import type {IFilterOption} from '../../types/galleryTypes';

export const spreadChoiceGroup = (option: IFilterOption): string[] => {
  if (option.childIds?.length) {
    return [option.id, ...option.childIds];
  }
  return [option.id];
};

export const spreadSelectedChoiceGroups = (activeOptions: string[], allOptions: IFilterOption[]): string[] => {
  return activeOptions
    .map((optionKey) => allOptions.find((o) => o.key === optionKey))
    .filter(Boolean)
    .flatMap(spreadChoiceGroup);
};
